import { gql } from '@apollo/client';

export const GET_TOP_EMPLOYEES = gql`
    query TopEmployees($dateFromTo: DateFromTo!) {
        topEmployees(dateFromTo: $dateFromTo) {
            id
            firstName
            lastName
            billCount
            totalPriceSold
        }
    }
`;
export const GET_TOP_PRODUCTS = gql`
    query TopProducts($dateFromTo: DateFromTo!) {
        topProducts(dateFromTo: $dateFromTo) {
            id
            name
            quantity
            totalPriceSold
            netMargin
            foodCost
        }
    }
`;

export const GET_UNPOPULAR_PRODUCTS = gql`
    query UnpopularProducts($dateFromTo: DateFromTo!) {
        unpopularProducts(dateFromTo: $dateFromTo) {
            id
            name
            quantity
            totalPriceSold
            netMargin
            foodCost
        }
    }
`;

export const GET_TOP_CATEGORIES = gql`
    query TopCategories($dateFromTo: DateFromTo!) {
        topCategories(dateFromTo: $dateFromTo) {
            id
            name
            totalPriceSold
            quantity
            color
            netMargin
            foodCost
            productWithNoRecipeCount
        }
    }
`;

export const GET_UNPOPULAR_CATEGORIES = gql`
    query UnpopularCategories($dateFromTo: DateFromTo!) {
        unpopularCategories(dateFromTo: $dateFromTo) {
            id
            name
            totalPriceSold
            quantity
            color
            netMargin
            foodCost
            productWithNoRecipeCount
        }
    }
`;
export const GET_TOP_TABLE = gql`
    query TopTable($dateFromTo: DateFromTo!) {
        topTable(dateFromTo: $dateFromTo) {
            id
            name
            orderQuantity
            totalPriceSold
        }
    }
`;

export const GET_PENDING_ORDERS = gql`
    query PendingOrders {
        pendingOrders {
            pendingTotalPrice
            orderQuantity
        }
    }
`;

export const GET_CHART_DATA = gql`
    query SalesChart($dateFromTo: DateFromTo!) {
        salesChartData(dateFilter: $dateFromTo) {
            income
            date
            paymentMethod
        }
    }
`;

export const GET_GROSS_INCOME_BY_PAYMENT_METHOD = gql`
    query GrossIncomeByPaymentMethod($dateFromTo: DateFromTo!) {
        venues {
            id
            dueDate
            debt
        }
        employeePermissions{
            warehouse
            backoffice
        }
        grossIncomeByPaymentMethod(dateFilter: $dateFromTo) {
            income
            paymentMethod
            paymentIntegrationPartner
        }
    }
`;

export const GET_AVERAGE_ORDER_STATISTICS = gql`
    query averageOrderStatistics($dateFromTo: DateFromTo!) {
        averageOrderStatistics(dateFilter: $dateFromTo) {
            billCount
            itemsPerOrder
            averageBillAmount
            orderCount
        }
    }
`;

export const GET_CANCELATIONS_DISCOUNTS_VOIDED = gql`
    query CancelationsDiscountsVoided($dateFromTo: DateFromTo!) {
        voidedBills(dateFromTo: $dateFromTo){
            itemCount
            voidedValue
        }
        discountedOrderLines(dateFromTo: $dateFromTo){
            itemCount
            discountedValue
        }
        canceledOrderLines(dateFromTo: $dateFromTo){
            itemCount
            canceledValue
        }
    }
`;

export const GET_MONEY_FLOW_REPORT = gql`
    query GetMoneyFlowReport($dateFromTo: DateFromTo) {
        moneyFlowReport(dateFromTo: $dateFromTo)
    }
`;
